export default __webpack_public_path__ + "static/media/micheline.2a805193.jpg";